import React, { useState } from 'react';
import Toast from 'react-native-tiny-toast';
import { View, StyleSheet, Image, TouchableOpacity } from 'react-native';
import * as Yup from 'yup';
import Screen from '../components/shared/Screen';
import { registerUser1, registerUser2 } from './../api/users';
import {
    ToplearnForm,
    ToplearnFormField,
    SubmitButton,
} from '../components/forms';
import { loadingToast, customToast } from '../utils/toasts';

const validationSchema1 = Yup.object().shape({
    meliCode: Yup.string()
        .min(10)
        .max(10)
        .required('کدملی ده رقم و الزامی می باشد.'),
    mobile: Yup.string()
        .min(11)
        .max(11)
        .required('شماره موبایل یازده رقم و الزامی می باشد'),
    // password: Yup.string()
    //     .required("این فیلد الزامی می باشد")
    //     .min(4, "کلمه عبور نباید کمتر از 4 کاراکتر باشد"),
    // passwordConfirmation: Yup.string()
    //     .required("تکرار کلمه عبور الزامی می باشد")
    //     .oneOf([Yup.ref("password"), null], "کلمه های عبور باید یکسان باشند"),
});
const validationSchema2 = Yup.object().shape({
    taeedCode: Yup.number()
        .required('کد تایید عدد بوده و الزامی می باشد.'),
    password: Yup.string()
        .required("این فیلد الزامی می باشد")
        .min(4, "کلمه عبور نباید کمتر از 4 کاراکتر باشد"),
    passwordConfirmation: Yup.string()
        .required("تکرار کلمه عبور الزامی می باشد")
        .oneOf([Yup.ref("password"), null], "کلمه های عبور باید یکسان باشند"),
});

const RegisterScreen = ({ navigation }) => {
    const [step, setStep] = useState('1');
    const [cdmli, setCdmli] = useState('');
    const [mbl, setMbl] = useState('');

    const handleUserRegistration1 = async (user) => {
        try {
            loadingToast('بررسی اطلاعات و ارسال کد تایید..');
            const status = await registerUser1(user);
            if (status === 200) {
                //navigation
                Toast.hide();
                setStep('2');
                setCdmli(user.meliCode);
                setMbl(user.mobile);
            } else {
                //show error
                Toast.hide();
                customToast('خطایی رخ داده است');
            }
        } catch (err) {
            console.log(err);
        }
    };

    const handleUserRegistration2 = async (user) => {
        try {
            loadingToast('ثبت نام کاربر...');
            const status = await registerUser2({
                meliCode:cdmli,
                mobile:mbl,
                taeedCode:user.taeedCode,
                password:user.password
            });
            if (status === 201) {
                //navigation
                Toast.hide();
                navigation.navigate('Login', { successRegister: true });
            } else {
                //show error
                Toast.hide();
                customToast('خطایی رخ داده است');
            }
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <Screen style={styles.container}>
            <Image style={styles.logo} source={require('../assets/logo.png')} />
            {step === '1' ? (
                <ToplearnForm
                    initialValues={{
                        meliCode: '',
                        mobile: '',
                    }}
                    onSubmit={(user) => {
                        handleUserRegistration1(user);
                    }}
                    validationSchema={validationSchema1}
                >
                    <ToplearnFormField
                        placeholder="شماره موبایل"
                        autoCorrect={false}
                        keyboardType="numeric"
                        icon="account-circle"
                        name="mobile"
                        placeholderTextColor="royalblue"
                    />
                    <ToplearnFormField
                        placeholder="کد ملی"
                        autoCorrect={false}
                        keyboardType="numeric"
                        icon="email"
                        name="meliCode"
                        placeholderTextColor="royalblue"
                    />
                    <View style={{ width: '60%' }}>
                        <SubmitButton title="ارسال کد تایید" />
                    </View>
                </ToplearnForm>
            ) : null}

            {step === '2' ? (
                <ToplearnForm
                    initialValues={{
                        taeedCode: '',
                        password: '',
                        passwordConfirmation: '',
                    }}
                    onSubmit={(user) => {
                        handleUserRegistration2(user);
                    }}
                    validationSchema={validationSchema2}
                >
                    <ToplearnFormField
                        placeholder="کد تایید"
                        autoCorrect={false}
                        keyboardType="numeric"
                        icon="account-circle"
                        name="taeedCode"
                        placeholderTextColor="royalblue"
                    />
                    <ToplearnFormField
                        placeholder="کلمه عبور"
                        autoCorrect={false}
                        icon="onepassword"
                        name="password"
                        placeholderTextColor="royalblue"
                        secureTextEntry
                    />
                    <ToplearnFormField
                        placeholder="تکرار کلمه عبور"
                        autoCorrect={false}
                        icon="onepassword"
                        name="passwordConfirmation"
                        placeholderTextColor="royalblue"
                        secureTextEntry
                    />
                    <View style={{ width: '60%', flexDirection: 'row' }}>
                        <SubmitButton title="ثبت نام" />
                        <TouchableOpacity
                            onPress={() => {
                                setStep('1');
                            }}
                        >
                            <Image
                                style={styles.backImage}
                                source={require('../assets/back.png')}
                            />
                        </TouchableOpacity>
                    </View>
                </ToplearnForm>
            ) : null}
        </Screen>
    );
};

export default RegisterScreen;

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
    },
    logo: {
        width: 190,
        height: 190,
        marginTop: 20,
        marginBottom: 40,
    },
    backImage: {
        width: 55,
        height: 55,
        marginLeft: 15,
        marginTop: 5,
        borderRadius: 15,
    },
});
